// extracted by mini-css-extract-plugin
export default {"wrapper":"student_wrapper__kpu-B","rotateY":"student_rotateY__PYI+Y"};